import { Route, Routes } from "react-router-dom";
import Nav from "@/components/Layout/Nav";
import Footer from "@/components/Layout/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";
import Landing from "@/pages/Landing";
import Swap from "@/pages/Swap";
import LP from "@/pages/LP";
import Stake from "@/pages/Stake";
import Referrals from "@/pages/Referrals";
import Mint from "@/pages/Mint";
import Hall from "@/pages/Hall";
import Radar from "@/pages/Radar";
import { useAutoAttribute } from "@/hooks/useReferrals";

export default function App() {
    // C2 fix: consume ?ref=<code> URL params and call attribute() on first
    // wallet connect when the user isn't already attributed.
    useAutoAttribute();

    return (
        <div className="min-h-screen flex flex-col">
            <ScrollToTop />
            <Nav />
            <main className="flex-1">
                <Routes>
                    <Route path="/"          element={<Landing />} />
                    <Route path="/swap"      element={<Swap />} />
                    <Route path="/lp"        element={<LP />} />
                    <Route path="/stake"     element={<Stake />} />
                    <Route path="/referrals" element={<Referrals />} />
                    <Route path="/mint"      element={<Mint />} />
                    <Route path="/hall"      element={<Hall />} />
                    <Route path="/radar"     element={<Radar />} />
                </Routes>
            </main>
            <Footer />
        </div>
    );
}
